const isAdmin = {
  computed: {
    isAdmin() {
      const { currentUser } = this.$store.state;
      if (currentUser) {
        return ['ADMIN', 'SUPER'].includes(currentUser.type);
      }
      return false;
    },
  },
};

export default isAdmin;



// WEBPACK FOOTER //
// ./src/mixins/isAdmin.js